import React from 'react';
import cs from 'classnames';
import { translate } from '@shakkerai/util-i18n';
import LoadingMoreIcon from '../../../assets/loading.gif';

const LoadMore = ({ className, style = {} }) => {
  return (
    <div style={style} className={cs('w-full flex justify-center text-[#969696]', className)}>
      <div className="w-24 text-left flex h-5">
        {translate('loading')}
        <img src={LoadingMoreIcon} alt="" className="w-3" />
      </div>
    </div>
  );
};
export default LoadMore;
